// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"5502498e","453":"a2858b9f","732":"770383f0","977":"6f89d731"}[chunkId] + ".chunk.js";
};